import { verifyToken } from '../actions/user'

export async function setConfig (u, t) {
  let token = ''
  const res = await verifyToken(u, t)
  if (res.data) token = res.data.token
  return { headers: { Authorization: `Bearer ${token}` } }
}
